import Vue from "vue";
import Router from "vue-router";
import { authenticationService } from "@/services/AuthenticationService";
import { UserRoutes } from "@/router/userRoutes";
import { SetupRoutes } from "@/router/setupRoutes";
import { ExhibitorRoutes } from "@/router/exhibitorRoutes";
import { DistributorRoutes } from "@/router/distributorRoutes";
import { MasterRoutes } from "@/router/masterRoutes";
import { FnbRoutes } from "@/router/fnbRoutes";
import { ReportsRoutes } from "@/router/reportsRoutes";
import { MarketingRoutes } from "@/router/marketingRoutes";
import { QrCodeRoutes } from "@/router/qrCodeRoutes";
import { MobileRoutes } from "@/router/mobileRoutes";
import { MarketingAutomationRoutes } from "@/router/marketingAutomation";
import { RoleManagementRoutes } from "@/router/rolemanagementRoutes";
import { cinemaRoutes } from "@/router/cinemaRoutes";
import { MyCinemaRoutes } from "@/router/myCinemaRoutes";
import { PagesRoutes } from "@/router/pagesRoutes";
import { SignageRoutes } from "@/router/signageRoutes";
import { PopupRoutes } from "@/router/popUpRoutes";
import { VoucherRoutes } from "@/router/voucherRoutes";
import { getPermissions } from "@/helper/collection";
import moment from "moment";
import UserService from "@/services/UserService";
import { CLIENT_NAME } from "@/helper/Role";

Vue.use(Router);

const ifNotAuthenticated = (to, from, next) => {
  if (Vue.cookie.get("BRHSID")) {
    console.log("ifNotAuthenticated First If");
    return next();
  } else {
    console.log("ifNotAuthenticated Second else");
    return next("/login");
  }
};
// const redirectToPage = (to) => {
//   if (!Vue.cookie.get("BRHSID") || !Vue.cookie.get("BRLF")) {
//     console.log("Inside Not First IF");
//     window.localStorage.clear();
//     Vue.cookie.delete("BRHSID");
//     Vue.cookie.delete("BRLF");
//   }
//   console.log("Outside First IF");
//   if (Vue.cookie.get("BRLF") == "IT-login") {
//     window.location.reload();
//   }
//   return Vue.cookie.get("BRHSID") && Vue.cookie.get("BRLF")
//     ? Vue.cookie.get("BRLF") == "admin-login"
//       ? "/home"
//       : Vue.cookie.get("BRLF") == "pos-login"
//       ? "pos-login"
//       : Vue.cookie.get("BRLF") == "pos-fnb-login"
//       ? "/pos-fnb-login"
//       : Vue.cookie.get("BRLF") == "IT-login"
//       ? "/screening-schedule-url"
//       : "/"
//     : "/login";
// };

const redirectToPage = (to) => {
  const brhsid = Vue.cookie.get("BRHSID");
  const brlf = Vue.cookie.get("BRLF");

  // Clear cookies and localStorage if BRHSID or BRLF is not set
  if (!brhsid || !brlf) {
    console.log("Inside Not First IF");
    window.localStorage.clear();
    Vue.cookie.delete("BRHSID");
    Vue.cookie.delete("BRLF");
    return "/login"; // if missing cookies, always go to login
  }

  // Handle role-based redirects
  if (brlf === "admin-login") {
    return "/home";
  }

  if (brlf === "IT-login") {
    window.location.reload();
    return; // no redirect needed, reload takes over
  }

  // Default fallback
  return "/login";
};

export const router = new Router({
  // mode: "history",
  mode: "hash",
  scrollBehavior: () => ({
    y: 0,
  }),
  routes: [
    SetupRoutes,
    MobileRoutes,
    {
      name: "Checklist Category",
      path: "/data-listing-table",
      component: () => import("@/components/static-ui/data-listing-table.vue"),
    },
    {
      path: "/mobile-support-checklist-category",
      name: "Mobile Checklist Category",
      component: () =>
        import(
          "@/components/Pages/mobileSupportContainer/mobileSupportCheckListCategory.vue"
        ),
    },
    {
      path: "/mobile-support-checklist-view",
      name: "Mobile Checklist View",
      component: () =>
        import(
          "@/components/Pages/mobileSupportContainer/mobileSupportCheckListView.vue"
        ),
    },
    {
      path: "/mobile-support-checklist-items",
      name: "Checklist Items",
      component: () =>
        import(
          "@/components/Pages/mobileSupportContainer/mobileSupportCheckListItems.vue"
        ),
    },
    {
      path: "/mobile-support-ticketing",
      name: "Mobile Support Ticketing",
      component: () =>
        import(
          "@/components/Pages/mobileSupportTicketComponent/mobileSupportTicketing.vue"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          144,
          1
        ),
      },
    },
    ,
    {
      path: "/add-mobile-support-ticketing",
      name: "Add Mobile Support Ticketing",
      component: () =>
        import(
          "@/components/Pages/mobileSupportTicketComponent/addMobileSupportTicketing.vue"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          144,
          2
        ),
      },
    },

    {
      path: "/edit-mobile-support-ticketing",
      name: "Edit Mobile Support Ticketing",
      component: () =>
        import(
          "@/components/Pages/mobileSupportTicketComponent/editMobileSupportTicketing.vue"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          144,
          2
        ),
      },
    },

    {
      path: "/view-mobile-support-ticketing",
      name: "View Mobile Support Ticketing",
      component: () =>
        import(
          "@/components/Pages/mobileSupportTicketComponent/viewMobileSupportTicketing.vue"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          144,
          1
        ),
      },
    },
    {
      path: "/mycinema-support-ticket",
      name: "View Mycinema Support Ticket",
      component: () =>
        import(
          "@/components/Pages/MycinemaSupportTicket/MycinemaSupportTicket.vue"
        ),
      meta: {},
    },

    {
      path: "/",
      beforeEnter: ifNotAuthenticated,
      redirect: redirectToPage,
      name: "Home",
      component: () => import("@/components/Containers/Landing"),
      children: [
        {
          path: "home",
          name: "",
          redirect: "/home/homepage",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "homepage",
              name: "HomePage",
              component: () => import("@/components/Pages/HomeContainer/Home"),
            },
          ],
        },
        UserRoutes,
        ExhibitorRoutes,
        DistributorRoutes,
        MasterRoutes,
        FnbRoutes,
        ReportsRoutes,
        MarketingRoutes,
        MarketingAutomationRoutes,
        // ACLRoutes,
        RoleManagementRoutes,
        cinemaRoutes,
        MyCinemaRoutes,
        PopupRoutes,
        PagesRoutes,
        QrCodeRoutes,
        SignageRoutes,
        VoucherRoutes,

        /**
         * ERROR ROUTES START
         */

        {
          path: "/404",
          name: "404",
          component: () => import("@/components/Pages/Error/404.vue"),
        },
        {
          path: "/expired",
          name: "Expired",
          component: () => import("@/components/Pages/Error/Expired.vue"),
        },
        {
          path: "/something-went-wrong",
          name: "Something Went Wrong",
          component: () =>
            import("@/components/Pages/Error/somethingWentWrong.vue"),
        },
        {
          path: "/access-denied",
          name: "Access Denied",
          component: () => import("@/components/Pages/Error/accessDenied.vue"),
        },
        // ERROR ROUTES ENDs
      ],
    },

    /**
     * POS FNB ROUTES START
     */

    /**
     * POS FNB ROUTES END
     */

    {
      path: "/go-to-login",
      name: "Login",
      component: () => import("@/components/Installation/welcome"),
    },

    {
      path: "/login",
      name: "UserLogin",
      component: () => import("@/components/Pages/login.vue"),
    },

    // SIGNAGE
    {
      path: "/signage-dynamic/:su_id",
      name: "New Signage",
      component: () => import("@/components/Signage/signageDynamic.vue"),
    },
    {
      path: "/signage/:id",
      name: "UserSignageLogin",
      component: () => import("@/components/Signage/signage.vue"),
    },
    {
      path: "/signageNowShow/:id1/:id2",
      name: "SignageNowShow",
      component: () => import("@/components/Signage/signage_NowShow.vue"),
    },

    {
      path: "/signageNextChange/:id1/:id2",
      name: "SignageNextChange",
      component: () => import("@/components/Signage/signage_Nextchange.vue"),
    },

    {
      path: "/signageComingSoon/:id",
      name: "SignageComingSoon",
      component: () => import("@/components/Signage/signage_ComingSoon.vue"),
    },
    {
      path: "/signageLatestRelease/:id",
      name: "SignageLatestRealse",
      component: () => import("@/components/Signage/signage_LatestRelease.vue"),
    },

    // 404 Page Not found
    {
      path: "*",
      name: "Error404",
      component: () => import("@/components/Pages/Error/404.vue"),
    },
    {
      path: "/sales-new",
      name: "Error404",
      component: () =>
        import(
          "@/components/Pages/ExhibitorManagement/reportBuilderComponents/reportBuilderComponentsSales.vue"
        ),
    },
    // src\components\
    {
      path: "/fnb-orders-url",
      name: "Error404",
      component: () =>
        import(
          "@/components/Pages/FoodAndBeveragesContainer/FnBOrdersComponent/FnbAppOrderUrlComp"
        ),
    },
    {
      path: "/screening-schedule-url",
      name: "Error404",
      name: "screenSchedulingSingle",
      component: () =>
        import("@/components/Pages/ReportsContainer/screenSchedulingSingle"),
    },
    {
      path: "/screening-schedule",
      name: "Error404",
      component: () =>
        import("@/components/Pages/ReportsContainer/screenScheduling"),
    },
  ],
});

const onLogout = () => {
  return new Promise((reject, resolve) => {
    UserService.removeToken()
      .then((res) => {
        const { data } = res;
        if (data.status == true) {
          window.localStorage.removeItem("JWT_TOKEN");
          window.localStorage.clear();
          Vue.cookie.delete("BRHSID");
          Vue.toasted.show("Session Expired!");
          resolve();
        } else {
          Vue.toasted.show("Session Expired!");
          window.localStorage.removeItem("JWT_TOKEN");
          window.localStorage.clear();
          Vue.cookie.delete("BRHSID");
          resolve();
        }
      })
      .catch((err) => {
        Vue.toasted.show("Session Expired!");
        resolve();
        console.log("err", err);
      });
  });
};
router.afterEach((to, from) => {
  let urlPath = window.location.hash;

  Vue.nextTick(() => {
    if (urlPath.includes("/pos-") || urlPath.includes("/box-office-fnb")) {
      document.title = "POS";
    } else {
      document.title = "DashBoard";
    }
  });
});

router.beforeEach((to, from, next) => {
  let cinema_value = localStorage.getItem("dropDownCinema")
    ? JSON.parse(localStorage.getItem("dropDownCinema")).cine_id == "all"
    : false;
  if (cinema_value) {
    localStorage.removeItem("dropDownCinema");
  }
  if (localStorage.getItem("session_expiry_time")) {
    let expiryTime = moment(localStorage.getItem("session_expiry_time")).format(
      "YYYY-MM-DD HH:mm"
    );
    let currentTime = moment().format("YYYY-MM-DD HH:mm");
    if (moment(currentTime).isAfter(expiryTime)) {
      window.localStorage.removeItem("JWT_TOKEN");
      window.localStorage.clear();
      Vue.cookie.delete("BRHSID");
      Vue.toasted.show("Session Expired!");
      return next({
        path: "/login",
      });
    }
  }
  // redirect to login page if not logged in and trying to access a restricted page

  const { permissions } = to.meta;
  const currentUserValue = authenticationService.get("USINFO"); // authenticationService.currentUserValue;
  if (permissions) {
    if (!currentUserValue && !currentUserValue["role_name"]) {
      return next({
        path: "/login",
      });
    }
    let role_id = currentUserValue.role_id;
    let module_list = authenticationService.get("module_list");
    // console.log(module_list, "module_list");
    // console.log(
    //   permissions.filter(
    //     ({ moduleID }) => module_list.includes(moduleID) || !moduleID
    //   ),
    //   "permissions.filter"
    // );

    if (
      permissions.length &&
      Array.isArray(permissions) &&
      module_list &&
      module_list.length &&
      role_id != 1 &&
      role_id != 2 &&
      role_id != 3 &&
      permissions.filter(
        ({ moduleID }) => module_list.includes(moduleID) || !moduleID
      ).length == 0
    ) {
      return next({
        path: "/access-denied",
      });
    }

    // check if route is restricted by role
    // if (
    //   permissions.length &&
    //   permissions.filter(
    //     ({ role }) => role.trim() === currentUserValue["role_name"].trim()
    //   ).length == 0
    // ) {
    //   return next({
    //     path: "/access-denied",
    //   });
    // }
  }

  if (
    from.name == "Kitchen Display" &&
    to.name != "UserLogin" &&
    to.name != "Pos-Booking" &&
    to.name != "Pos Food N Beverages" &&
    to.name != "POS Login" &&
    to.name != "Kitchen Pickup"
  ) {
    return next({
      path: "/kitchen-sales",
    });
  } else if (
    from.name == "Kitchen Pickup" &&
    to.name != "UserLogin" &&
    to.name != "Pos-Booking" &&
    to.name != "Pos Food N Beverages" &&
    to.name != "POS Login" &&
    to.name != "Kitchen Display"
  ) {
    return next({
      path: "/kitchen-pickup",
    });
  }
  next();
});



// WEBPACK FOOTER //
// ./src/router/index.js